import { LOGGED_IN, LOGGED_OUT, ERROR, SUCCESS, EMPTY_CART } from './types';
import { auth, emailAuthProvider, users } from '../firebase';
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import { fetchCartAndUserProfile } from './cartActions';

export const authError = (error) => {
    return {
        type: ERROR,
        payload: error.message,
    };
};

const signIn = (user) => {
    return {
        type: LOGGED_IN,
        payload: user,
    };
};

const signOut = () => {
    return {
        type: LOGGED_OUT,
    };
};

const emptyCart = () => {
    return {
        type: EMPTY_CART,
    };
};

export const emailPasswordRegister = (email, password, history, from) => async (
    dispatch
) => {
    auth.createUserWithEmailAndPassword(email, password)
        .then(() => {
            history.replace({
                pathname: '/profile',
                state: { from },
            });
        })
        .catch((error) => {
            dispatch(authError(error));
        });
};

export const linkAccount = (email, password, history, from) => async (
    dispatch
) => {
    var credential = emailAuthProvider.credential(email, password);
    auth.currentUser
        .linkWithCredential(credential)
        .then(() => {
            history.replace({
                pathname: '/profile',
                state: { from },
            });
            dispatch({
                type: SUCCESS,
                payload: 'upgrade account successful',
            });
        })
        .catch((err) => {
            dispatch(authError(err));
        });
};

export const updateUserInfo = (name, history, phone) => async (
    dispatch,
    getState
) => {
    dispatch(showLoading());
    Promise.all([
        auth.currentUser.updateProfile({ displayName: name }),
        users.doc(getState().user.uid).set({ phone: phone }, { merge: true }),
    ])
        .then(() => {
            dispatch(hideLoading());
            if (history.location.state) {
                history.replace(history.location.state.from);
            }
        })
        .catch((err) => dispatch(authError(err)));
};

export const emailPasswordSignin = (email, password) => async (dispatch) => {
    auth.signInWithEmailAndPassword(email, password).catch((error) => {
        dispatch(authError(error));
    });
};

export const anonymousSignin = () => async (dispatch) => {
    dispatch(showLoading());
    auth.signInAnonymously()
        .then(() => {
            dispatch(hideLoading());
        })
        .catch((error) => {
            dispatch(authError(error));
        });
};

export const watchAuthStatus = () => async (dispatch) => {
    auth.onAuthStateChanged((user) => {
        if (user) {
            dispatch(signIn(user));
            dispatch(fetchCartAndUserProfile(user.uid));
        } else {
            dispatch(signOut());
            dispatch(emptyCart());
        }
    });
};
